var App = App || {};

App.ComponentSsYaCards = (function ($) {
    'use strict';

    function Init() {
        $(".component-ssYaCards").each(function () {

            const widget = $(this);

            CardsHeight(widget);
            $(window).on("resize", function () { CardsHeight(widget); });
            Carousel(widget);
            CardsFlip(widget);
            
        });
    }

    function CardsHeight(widget) {

    const cards = widget.find(".item-ssYaCard");

    let maxHeight = 0;

    cards.each(function () {

        const front = $(this).find(".item-ssYaCard-front");
        const back = $(this).find(".item-ssYaCard-back");

        front.css({ position: "static", height: "auto" });
        back.css({ position: "static", height: "auto" });

        maxHeight = Math.max(
            maxHeight,
            front.outerHeight(),
            back.outerHeight()
        );

        front.removeAttr("style");
        back.removeAttr("style");
    });

    cards.each(function () {
        $(this)
            .find(".item-ssYaCard-front, .item-ssYaCard-back")
            .height(maxHeight);
    });
}

    function CardsFlip(widget) {

        const cards = widget.find(".item-ssYaCard");
        const buttons = cards.find("button");

        buttons.on("click", function () {
            const card = $(this).parents(".item-ssYaCard");
            card.attr("aria-selected", card.attr("aria-selected") == "false");
        })
    }

    function Carousel(widget) {

        const carousel = widget.find(".splide");
        const splide = new Splide(carousel[0], {
            type: "loop",
            perPage: 3,
            gap: "3rem",
            breakpoints: {
                1199: {
                    gap: "1rem",
                },
                767: {
                    perPage: 1,
                },
            }
        });

        splide.mount({});   
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentSsYaCards.Init();
});